import React from 'react';
import './OpenHours.css';

const OpenHours = () => {
  return (
    <div className="open-hours">
      <h2 className="hours-title">Open Hours</h2>
      <div className="hours-grid">
        <div className="hours-section">
          <h3>Monday</h3>
          <div className="brunch-badge">Brunch 9 AM–2 PM</div>
          <p>Breakfast / Lunch 9 am - 2 pm</p>
        </div>

        <div className="hours-section">
          <h3>Tuesday - Thursday</h3>
          <div className="brunch-badge">Brunch 9 AM–2 PM</div>
          <p>Breakfast / Lunch 9 am - 2 pm</p>
          <p>Dinner 3 pm - 9 pm</p>
        </div>

        <div className="hours-section">
          <h3>Friday - Saturday</h3>
          <div className="brunch-badge">Brunch 9 AM–2 PM</div>
          <p>Breakfast / Lunch 9 am - 2 pm</p>
          <p>Dinner / Late Night 3 pm - 12 am</p>
        </div>

        <div className="hours-section">
          <h3>Sunday</h3>
          <div className="brunch-badge">Brunch 8:30 AM–3 PM</div>
          <p>Breakfast / Lunch 8:30 am - 3 pm</p>
        </div>
      </div>
    </div>
  );
};

export default OpenHours; 